type Props = {
  className?: string;
};

export default function DoneCheck({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_7323_9682)">
        <path
          d="M8 17.6307L11.2667 22.2667C11.3906 22.4518 11.5569 22.6046 11.7518 22.7124C11.9467 22.8203 12.1645 22.88 12.3872 22.8866C12.6098 22.8933 12.8308 22.8467 13.0318 22.7507C13.2328 22.6547 13.4079 22.512 13.5427 22.3347L24 9.104"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 15.9985C1 19.9768 2.58035 23.7921 5.3934 26.6051C8.20644 29.4182 12.0218 30.9985 16 30.9985C19.9782 30.9985 23.7936 29.4182 26.6066 26.6051C29.4196 23.7921 31 19.9768 31 15.9985C31 12.0203 29.4196 8.20498 26.6066 5.39193C23.7936 2.57889 19.9782 0.998535 16 0.998535C12.0218 0.998535 8.20644 2.57889 5.3934 5.39193C2.58035 8.20498 1 12.0203 1 15.9985Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7323_9682">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
